import CRUD from './crud'
import axios from '../../utils/axios';

const tournamentSchedules = new CRUD('tournament-schedules')

export default Object.assign(
    tournamentSchedules,
    {
        reducers: {
            ...tournamentSchedules.reducers
        },

    }
)
